import { Component, inject } from '@angular/core';
import { SearchModal } from '../../../feature/search-bar/search-modal/search-modal';
import { MatDialog } from '@angular/material/dialog';
import { select } from '@ngxs/store';
import { LayoutState } from '@dis/shared';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'jtms-header-search',
  imports: [MatIcon],
  templateUrl: './header-search.html',
  styleUrl: './header-search.css',
  host: { '(document:keydown)': 'handleKeyboardEvent($event)' },
})
export class HeaderSearch {
  #dialog = inject(MatDialog);

  isHandset = select(LayoutState.isHandset);

  handleKeyboardEvent(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.openSearchModal();
    }
  }

  openSearchModal(): void {
    this.#dialog.open(SearchModal, {
      position: { top: '80px' },
      width: '760px',
      maxWidth: '95vw',
      panelClass: 'search-modal-panel',
    });
  }
}
